// Detect devices rather than viewport width so small desktop windows stay usable.
export const isMobileBrowser = (device = navigator) => {
	return device.userAgentData?.mobile === true ||
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(device.userAgent || '') ||
		(device.platform === 'MacIntel' && device.maxTouchPoints > 1)
}
